import sortOptionsAPI from '@/api/sort_options'

export const getDefaultSortingOptions = ({ commit }, params) => {
  return new Promise((resolve, reject) => {
    sortOptionsAPI.getDefaultSortingOptions(params, result => {
      resolve(result.data)
    })
  })
}

export const saveProductDefaultSortOptionSetting = ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    sortOptionsAPI.saveProductDefaultSortOptionSetting(param, result => {
      resolve(result.data)
    })
  })
}

export const saveCategoryDefaultSortOptionSetting = ({ commit }, param) => {
  return new Promise((resolve, reject) => {
    sortOptionsAPI.saveCategoryDefaultSortOptionSetting(param, result => {
      resolve(result.data)
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/sort_options/actions.js